module.exports = __webpack_public_path__ + "static/img/guide_1.ce7239a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/guide_1.jpg
// module id = cEmM
// module chunks = 1